import * as React from 'react';
import styled from 'styled-components';
import { PageWrap } from '../../layouts';
import { images, theme } from '../../theme';
import { SteynCityContext } from '../ContextProvider';

import Header from '../Header';
import SideBarLink from './SideBarLink';
import HamburgerIcon from './HamburgerIcon';
import { RouteArray } from '../../navigation/Routes';
import { Logo, LogoCont, SideBarWrapper, VersionCont } from './StyledElements';
import { getLoggedInUser } from '../../utils/helpers';
import { NavItems } from '../../utils/types';
import { IS_VENDOR } from '../../consts/index';
const pkg = require('../../../package.json');
import { Span } from '../../typography';

export type SideBarProps = {
  color?: string;
  className?: string;
  children?: React.ReactNode;
  routes?: RouteArray;
  navItems: NavItems[];
};

const RenderWrapper = styled.div`
  width: 100%;
  display: flex;
  min-height: 100vh;
  padding-left: 60px;
  flex-direction: column;
`;

const color = IS_VENDOR ? theme.colors.charcoalGrey : theme.colors.white;

class Sidebar extends React.Component<SideBarProps, {}> {
  static contextType = SteynCityContext;

  static defaultProps = {
    navItems: [],
  };

  context!: React.ContextType<typeof SteynCityContext>;

  /**
   * This function serves to render the NavItem if
   * the users role is included in the NavItems permissions array
   */

  renderNavLinks = (navItems: NavItems[]) => {
    const user = getLoggedInUser();
    const context = this.context;
    if (user && navItems) {
      return navItems
        .filter((x) => x.permissions && x.permissions.includes(user.role))
        .map((i) => (
          <SideBarLink
            to={i.to}
            parent={i.parent}
            key={i.title}
            icon={i.icon}
            title={i.title}
            subMenu={i.subMenu}
            color={color || 'white'}
            open={context.drawerOpen}
          />
        ));
    }
    return null;
  };

  render() {
    const { navItems, children } = this.props;
    const context = this.context;
    return (
      <PageWrap>
        <SideBarWrapper className="custom-sidebar" open={context.drawerOpen}>
          <LogoCont open={context.drawerOpen}>
            <HamburgerIcon onClick={context.toggleDrawer} open={context.drawerOpen} />
            <Logo open={context.drawerOpen} src={images.logo} />
          </LogoCont>
          <div style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
            {this.renderNavLinks(navItems)}
          </div>
          <VersionCont open={context.drawerOpen}>
            <Span color={color} style={{ fontSize: '10px', opacity: 0.8 }}>
              {context.drawerOpen ? `Version ${pkg.version}` : `v${pkg.version}`}
            </Span>
          </VersionCont>
        </SideBarWrapper>
        <RenderWrapper
          onClick={() => setTimeout(() => context[context.drawerOpen ? 'closeDrawer' : 'openDrawer'](), 1)}
        >
          <Header {...this.props} />
          {children}
        </RenderWrapper>
      </PageWrap>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/sidebar/index.tsx